// The account switcher's decisions, kept out of the component so they can be tested
// without driving the menu, and so the file stays fast-refreshable.

import type { BusinessUnit, UserAccountDto } from '@/types';

/**
 * The account you are in first, the rest in the server's order. The list scrolls at seven
 * rows, so further down it opens onto rows you are not using with your own below the fold.
 * The cost is that the list reshuffles each time you switch.
 *
 * Without the switcher the menu shows only the account you are in.
 */
export function accountMenuOrder(
	accounts: UserAccountDto[],
	currentAccountId: number | null,
	showAccountSwitcher: boolean
): UserAccountDto[] {
	const current = accounts.filter((account) => account.id === currentAccountId);
	if (!showAccountSwitcher) return current;
	return [...current, ...accounts.filter((account) => account.id !== currentAccountId)];
}

/** One brand is the whole account, so a panel opens only from the second one. */
export function opensBrandPanel(options: BusinessUnit[]): boolean {
	return options.length > 1;
}

/** Hides inactive brands, unless one is the current scope — deactivating must not move you. */
export function visibleBrands(units: BusinessUnit[], buId: string | null) {
	return units.filter((unit) => unit.status === 'active' || unit.id === buId);
}

